import { PropType, type Ref } from 'vue';
import { SelectListItemType } from '@domain/enums/SelectListItemType';
import type ISelectItem from '@domain/interfaces/dtos/ISelectItem';
import { IMultiselectOption } from '@app/interfaces/dtos/IMultiselectOption';
import { MultiselectMode } from '@app/enums/MultiselectMode';

export type ItemEntry = {
	item: ISelectItem;
	subItems?: ISelectItem[];
};

export const multiselectEmitsDefinition = {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	'updateValues': (_value: string | number | (string | number)[] | null): boolean => true,
	'open': (): boolean => true,
	'close': (): boolean => true,
	'changeContinent': (): boolean => true
};

export const multiselectPropsDefinition = {
	modelValue: {
		type: [String, Number, Array] as PropType<string | number | (string | number)[]>,
		default: null
	},
	options: {
		type: Array as PropType<IMultiselectOption[]>,
		required: true
	},
	mode: {
		type: String as PropType<MultiselectMode>,
		default: MultiselectMode.SINGLE
	},
	maxHeight: {
		type: String,
		default: '20rem'
	},
	placeholder: {
		type: String,
		default: 'Start typing to search'
	},
	disabled: {
		type: Boolean,
		default: false
	},
	searchable: {
		type: Boolean,
		default: false
	},
	canClear: {
		type: Boolean,
		default: true
	},
	noOptionsText: {
		type: String,
		default: 'No options available'
	},
	noResultsText: {
		type: String,
		default: 'No results found'
	},
	description: {
		type: String,
		default: ''
	},
	warning: {
		type: String,
		default: ''
	},
	isLocationFilter: {
		type: Boolean,
		default: false
	}
};

export interface MultiselectProps {
	modelValue: string | number | (string | number)[] | null;
	options: IMultiselectOption[];
	mode: MultiselectMode;
	maxHeight: string;
	placeholder: string;
	disabled: boolean;
	searchable: boolean;
	canClear: boolean;
	noOptionsText: string;
	noResultsText: string;
	description: string;
	warning: string;
	isLocationFilter: boolean;
}

export interface UseMultiselectOptions {
	props: MultiselectProps;
	emit: {
		(e: 'updateValues', value: string | number | (string | number)[] | null): void;
		(e: 'open' | 'close'): void;
	};
}

export interface UseMultiselectReturn {
	internalValue: Ref<string | number | (string | number)[] | null>;
	isOpen: Ref<boolean>;
	formattedOptions: Ref<{
		value: string | number;
		label: string;
		icon?: string;
		count?: number;
		disabled: boolean;
	}[]>;
	selectItemType: Ref<SelectListItemType>;
	mapOptionToSelectItem: (option: IMultiselectOption, isSelected: boolean) => ISelectItem;
	onOpen: () => void;
	onClose: () => void;
}
